import { EmployeeTransactionAttributeDTO, EmployeeTransactionDTO } from '@iota/iota-management-portal-v4-client';
import { createAction, props } from '@ngrx/store';

export enum EmployeeTransactionActionTypes {
    LoadTransactionsByCase = '[EmployeeTransaction] Load Transactions By Case',
    LoadTransaction = '[EmployeeTransaction] Load Transaction',

    LoadTransactionsSuccess = '[EmployeeTransaction] Load Transactions Success',
    LoadTransactionsFailure = '[EmployeeTransaction] Load Transactions Failure',

    UpsertTransaction = '[EmployeeTransaction] UpsertTransaction',
    UpsertTransactionSuccess = '[EmployeeTransaction] UpsertTransactionSuccess',
    UpsertTransactionFailure = '[EmployeeTransaction] UpsertTransactionFailure',

    DeleteTransaction = '[EmployeeTransaction] Delete Transaction',
    DeleteTransactionSuccess = '[EmployeeTransaction] Delete Transaction Success',
    DeleteTransactionFailure = '[EmployeeTransaction] Delete Transaction Failure'
}

export const LoadTransactionsByCase = createAction(
    EmployeeTransactionActionTypes.LoadTransactionsByCase,
    props<{ employeeCaseId: string }>()
);
export const LoadTransaction = createAction(EmployeeTransactionActionTypes.LoadTransaction, props<{ transactionId: string }>());

export const LoadTransactionsSuccess = createAction(
    EmployeeTransactionActionTypes.LoadTransactionsSuccess,
    props<{ transactions: EmployeeTransactionDTO[] }>()
);
export const LoadTransactionsFailure = createAction(EmployeeTransactionActionTypes.LoadTransactionsFailure, props<{ error: any }>());

export const UpsertTransaction = createAction(
    EmployeeTransactionActionTypes.UpsertTransaction,
    props<{ transaction: EmployeeTransactionDTO }>()
);
export const UpsertTransactionSuccess = createAction(
    EmployeeTransactionActionTypes.UpsertTransactionSuccess,
    props<{ transactionId: string; caseId: string; subscriptionId: string }>()
);
export const UpsertTransactionFailure = createAction(EmployeeTransactionActionTypes.UpsertTransactionFailure, props<{ error: any }>());

export const DeleteTransaction = createAction(
    EmployeeTransactionActionTypes.DeleteTransaction,
    props<{ transaction: EmployeeTransactionDTO }>()
);
export const DeleteTransactionSuccess = createAction(
    EmployeeTransactionActionTypes.DeleteTransactionSuccess,
    props<{ transactionId: string; caseId: string; subscriptionId: string }>()
);
export const DeleteTransactionFailure = createAction(EmployeeTransactionActionTypes.DeleteTransactionFailure, props<{ error: any }>());

export const UpsertTransactionAttributes = createAction(
    '[EmployeeTransaction] UpsertTransactionAttributes',
    props<{ transactionId: string; attributes: EmployeeTransactionAttributeDTO[] }>()
);
export const UpsertTransactionAttributesSuccess = createAction(
    '[EmployeeTransaction] UpsertTransactionAttributesSuccess',
    props<{ transactionId: string }>()
);
export const UpsertTransactionAttributesFailure = createAction(
    '[EmployeeTransaction] UpsertTransactionAttributesFailure',
    props<{ error: any }>()
);
